import * as UserRoles from './UserRoles';

export const HelperTableConfig = {
  UserRoles,
};
